// Los estados de tarea son de cada capsula y vienen en `capsule_config.task_statuses`. Aca
// quedan **solo etiquetas de respaldo** para los ids de plataforma: sirven mientras el
// catalogo no cargo, o para un estado viejo que ya no esta en la configuracion.
//
// La lista de estados se fue a proposito. Estaba escrita aca, en `MyWorkPage`, en
// `models/schemas.py` y en `routers/my_work.py`, y las cuatro decian cosas distintas: por eso
// "Avanzar" mandaba un `review` que la API no acepta y una tarea fallida no contaba en ningun
// lado del resumen. Ver `backend/tests/test_estados_de_tarea_sin_listas_paralelas.py`.
export const TASK_STATUS_LABELS = {
  todo: 'Por hacer',
  in_progress: 'En curso',
  blocked: 'Bloqueada',
  in_review: 'En revision',
  done: 'Hecha',
  cancelled: 'Cancelada',
  failed: 'Fallida',
};

/** Etiqueta de un estado: manda el catalogo, despues el respaldo, y por ultimo el id crudo. */
export function etiquetaDeEstadoDeTarea(catalogo, id) {
  if (!id) return '';
  const enCatalogo = (catalogo || []).find((e) => e?.id === id);
  return enCatalogo?.name || TASK_STATUS_LABELS[id] || id;
}

/**
 * Las columnas del tablero: lo que sigue abierto, mas el **primer** estado terminal.
 *
 * Es lo mismo que hacia el filtro `s !== 'failed' && s !== 'cancelled'`, pero preguntando por
 * banderas en vez de por nombres: una capsula de taller esconde "descartada" sin que la
 * plataforma sepa como se llama.
 */
export function columnasDeTablero(catalogo) {
  const estados = [...(catalogo || [])].sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));
  const abiertos = estados.filter((e) => e.cuenta_como_abierta !== false);
  const primerTerminal = estados.find((e) => e.es_terminal);
  return primerTerminal ? [...abiertos, primerTerminal] : abiertos;
}

export const PHASE_STATUS_COLORS = {
  pending: 'bg-zinc-100 text-zinc-600',
  in_progress: 'bg-blue-50 text-brand-primary',
  done: 'bg-green-50 text-green-700',
  skipped: 'bg-amber-50 text-amber-700',
};

export const TASK_TYPE_LABELS = {
  agent: 'Agente',
  human: 'Humano',
  system: 'Sistema',
  cross_capsule: 'Cross-capsula',
  // Una herramienta que un agente quiso ejecutar y espera que una persona le de permiso.
  // **Decia "Autorizacion pendiente" y era confuso**: desde el 2026-09-01 existe un tipo
  // `autorizacion` que es otra cosa —una persona autorizando un pedido— y dos rotulos casi
  // iguales sobre cosas distintas es como se toma una decision creyendo que es la otra.
  aprobacion: 'Permiso de herramienta',
  // Una persona tiene que dar el visto bueno a un pedido. No frena el caso: registra y avisa.
  autorizacion: 'Autorizacion',
};


/**
 * Etiqueta de **cualquier** catalogo de la capsula: `{id, name}`. Manda el nombre, cae al id.
 *
 * **El patron que este helper viene a cortar.** El relevamiento del 2026-10-01 encontro veinte
 * lugares con un id tecnico donde iba un nombre, y todos tenian la misma forma: *el detalle traduce,
 * la lista no — y la lista es donde se decide*. El header del caso usaba `statusName()` y la cola
 * mostraba `in_progress`; el selector de clasificacion usaba `capsuleIntents` y la fila mostraba
 * `soporte_aplicaciones`. Veinte parches se desincronizan; una funcion no.
 *
 * Cae al id crudo **a proposito**: un id visible es feo y se arregla: un guion esconderia que la
 * capsula tiene un valor que su catalogo no declara, que es justo lo que hay que ver.
 */
export function etiquetaDeCatalogo(catalogo, id) {
  if (!id) return '';
  const encontrado = (catalogo || []).find((x) => x?.id === id);
  return encontrado?.name || id;
}

//: El estado de una fase. **No es configurable y no sale de ningun catalogo**: son los cuatro
//: valores que `PUT /tickets/{id}/phases` acepta, escritos en el router. Lo que no puede pasar es
//: que la pantalla los muestre en ingles, como venia haciendo el `<select>` del tablero.
export const PHASE_STATUS_LABELS = {
  pending: 'Sin empezar',
  in_progress: 'En curso',
  done: 'Hecha',
  skipped: 'Salteada',
};

//: El estado de una verificacion. Mismo caso que el de las fases: tres valores de plataforma.
export const VERIFICATION_STATUS_LABELS = {
  pending: 'Pendiente',
  passed: 'Aprobada',
  failed: 'Rechazada',
};
